import React, { useState, useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
// import { ResetPasswordEdit } from "../../api/api";
import { ResetPasswordEdit } from "../api/api";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import "../SetResetPassword/SetResetPassword.css";
import Swal from "sweetalert2";
import bgImage from "../../assets/images/brown-background.jpg";

// Validation schema
const validationSchema = Yup.object().shape({
  code: Yup.string()
    .min(6, "Code must be at least 6 characters")
    .required("Code is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("New Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm New Password is required"),
});

const SetResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state?.values || {};

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword(!showConfirmPassword);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    console.log("valuessss0000000", values);
    try {
      const response = await ResetPasswordEdit(values);
      //   if (response?.success === true) {
      //     alert(response?.msg);
      //     navigate("/Sidebar/EditProfile");
      //   } else {
      //     alert(response?.msg || "Something went wrong");
      //   }
      if (response?.success === true) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.msg,
          confirmButtonColor: "#e04a48",
        }).then(() => {
          navigate("/Sidebar/EditProfile");
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response?.msg || "Something went wrong",
          confirmButtonColor: "#e04a48",
        });
      }
    } catch (error) {
      console.error("Reset Password Error:", error);
      alert("Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="reset-container"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="reset-container-div">
        <h2 className="reset-heading">Please Enter New Password</h2>

        <Formik
          initialValues={{
            code: "",
            password: "",
            confirmPassword: "",
            email: email || "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <form className="reset-form" onSubmit={handleSubmit}>
              {/* Code */}
              <div className="input-group">
                {/* <FaLock className="icon" /> */}
                <input
                  type="text"
                  name="code"
                  placeholder="OTP"
                  maxLength={6}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.code}
                />
              </div>
              {touched.code && errors.code && (
                <div className="error">{errors.code}</div>
              )}

              {/* New Password */}
              <div className="input-group">
                {/* <FaLock className="icon" /> */}
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="New Password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                />
                <span
                  onClick={togglePasswordVisibility}
                  className="toggle-icon"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              {touched.password && errors.password && (
                <div className="error">{errors.password}</div>
              )}

              {/* Confirm Password */}
              <div className="input-group">
                {/* <FaLock className="icon" /> */}
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirm New Password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.confirmPassword}
                />
                <span
                  onClick={toggleConfirmPasswordVisibility}
                  className="toggle-icon"
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              {touched.confirmPassword && errors.confirmPassword && (
                <div className="error">{errors.confirmPassword}</div>
              )}

              {/* Submit Button */}
              <button type="submit" className="submit-btn" disabled={isLoading}>
                {isLoading ? "Saving..." : "Save"}
              </button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SetResetPassword;
